import type { FaireProductEntity } from "../../entity_types/product";

export const p_yakzxuhag6: FaireProductEntity = {
  token: "p_yakzxuhag6",
  type: "product",
  name: "Navy Little Notes® Ceramic Holder",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/3dab6d781081bad13c04492e5fb2b3ab1f67a747921a2111c8bd30b156ae8259.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d9e5d1a38e6dff98021eab8e043341c2b0659da3960a9f68881d37aea74bf9a.jpeg",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png"
  ],
  priceDollars: 13,
  description: "Give your Little Notes® a cozy home on your desk or counter with this gorgeous ceramic cube. Substantial in weight and glazed in a matte finish, this accessory is the perfect gift for all Little Notes lovers!\n\nPerfectly fits two boxes of Little Notes® or 150 loose Little Notes®. Please note, Little Notes® must be purchased separately!",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:22.300Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
